import React, { useState } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import RemixArrowDownLineSVG from '../svg/icons/remix-arrow-down-line.svg';
import PopoverNav from './PopoverNav';

const NavItem = ({
  Component = PopoverNav,
  label,
  items = [],
  columns = [],
  handleOnClick = () => {},
  ...props
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((open) => !open);
  const hasSubItems = items.length > 0 || columns.length > 0 || false;

  const linkClass = classnames(
    'p-2 lg:py-3 lg:px-4 font-bold text-haiti lg:text-sm flex items-center justify-between w-full lg:w-auto focus:outline-none',
    {
      'lg:block relative': !hasSubItems,
      'cursor-default': hasSubItems,
    }
  );

  return (
    <li className="relative group" role="menuitem">
      {hasSubItems ? (
        <React.Fragment>
          <button
            className={linkClass}
            onClick={toggleMenu}
            onKeyDown={toggleMenu}
            aria-label={label}
            aria-haspopup="true"
            aria-expanded={menuOpen}
          >
            <span>{label}</span>
            <RemixArrowDownLineSVG
              className={classnames('h-4 fill-current lg:ml-1 lg:mr-2', {
                'transform rotate-180 md:rotate-0': menuOpen,
              })}
            />
          </button>
          <Component items={items} columns={columns} menuOpen={menuOpen} />
        </React.Fragment>
      ) : (
        <Link
          {...props}
          className={linkClass}
          onClick={handleOnClick}
          children={label}
        />
      )}
    </li>
  );
};

export default NavItem;
